import React from "react";
import logo from "../../../assets/newIcons/Lucky.png";

function Logo({ isSidebar }) {
    return (
        <div className="flex flex-col justify-center items-center mb-1">
            <img src={logo} alt="logo" className={`${isSidebar ? 'h-[8vh] duration-300 mb-4' : 'h-[14vh] duration-300 mb-2'}`} />
            <div
                className={`${isSidebar ? 'hidden' : 'text-waterFive'
                    }  text-[1.8rem] font-bold font-mmYein`}
            >
                Lucky 7
            </div>
        </div>
    );
}

export default Logo;
